/**
 * A form field name wrapped in double curly brackets - `{{email}}` - the same
 * notation the form emails and the GHL integration use.
 */
export const placeholderPattern = /\{\{(\w+)\}\}/g;

interface ResolvePlaceholdersArgs {
  template: string;
  values: Record<string, string>;
}

/** Every `{{field}}` becomes the matching value as is, a missing one empty. */
export const resolvePlaceholders = ({
  template,
  values,
}: ResolvePlaceholdersArgs): string =>
  template.replace(placeholderPattern, (_, field: string) => values[field] ?? '');
